const TEACHER_TOKEN_KEY = 'TOKEN';
const TEACHER_LOGIN_STATE_KEY = 'loginState';
const TEACHER_LOGIN_REDIRECT_KEY = 'TEACHER_LOGIN_REDIRECT';
const TEACHER_SKIP_AUTO_LOGIN_ONCE_KEY = 'TEACHER_SKIP_AUTO_LOGIN_ONCE';
const TEACHER_OAUTH_QUERY_KEYS = ['code', 'state', 'type'];

export function getTeacherToken() {
  return localStorage.getItem(TEACHER_TOKEN_KEY) || '';
}

export function setTeacherToken(token) {
  if (!token) {
    return;
  }
  localStorage.setItem(TEACHER_TOKEN_KEY, token);
}

export function clearTeacherToken() {
  localStorage.removeItem(TEACHER_TOKEN_KEY);
}

export function setTeacherLoginState(loginState) {
  localStorage.setItem(TEACHER_LOGIN_STATE_KEY, normalizeTeacherLoginState(loginState));
}

export function getTeacherLoginState() {
  return normalizeTeacherLoginState(localStorage.getItem(TEACHER_LOGIN_STATE_KEY));
}

export function resolveTeacherLoginState(input = '') {
  if (typeof input === 'string' && input.indexOf('/old') === 0) {
    return '0';
  }
  if (typeof input === 'string' && input.indexOf('/new') === 0) {
    return '1';
  }
  return normalizeTeacherLoginState(input);
}

function normalizeTeacherLoginState(input = '') {
  return String(input) === '0' ? '0' : '1';
}

export function getTeacherLoginPath(input = '') {
  return resolveTeacherLoginState(input) === '0' ? '/oldLogin' : '/newLogin';
}

export function rememberTeacherLoginRedirect(path, force = false) {
  if (!path) {
    return;
  }
  if (!force && sessionStorage.getItem(TEACHER_LOGIN_REDIRECT_KEY)) {
    return;
  }
  sessionStorage.setItem(TEACHER_LOGIN_REDIRECT_KEY, path);
}

export function consumeTeacherLoginRedirect() {
  const redirect = sessionStorage.getItem(TEACHER_LOGIN_REDIRECT_KEY) || '';
  sessionStorage.removeItem(TEACHER_LOGIN_REDIRECT_KEY);
  return redirect;
}

export function getTeacherLoginRedirect() {
  return sessionStorage.getItem(TEACHER_LOGIN_REDIRECT_KEY) || '';
}

export function markSkipTeacherAutoLoginOnce() {
  sessionStorage.setItem(TEACHER_SKIP_AUTO_LOGIN_ONCE_KEY, '1');
}

export function hasSkipTeacherAutoLoginOnce() {
  return sessionStorage.getItem(TEACHER_SKIP_AUTO_LOGIN_ONCE_KEY) === '1';
}

export function clearSkipTeacherAutoLoginOnce() {
  sessionStorage.removeItem(TEACHER_SKIP_AUTO_LOGIN_ONCE_KEY);
}

export function getTeacherOauthCode() {
  const match = window.location.search.match(/[?&]code=([^&]+)/);
  return match && match[1] ? decodeURIComponent(match[1]) : '';
}

function normalizeHash(targetHash = '') {
  if (!targetHash) {
    return window.location.hash || '#/newLogin';
  }
  if (targetHash.indexOf('#') === 0) {
    return targetHash;
  }
  if (targetHash.indexOf('/') === 0) {
    return `#${targetHash}`;
  }
  return `#/${targetHash}`;
}

function buildTeacherCleanUrl(targetHash = '') {
  const currentUrl = new URL(window.location.href);
  TEACHER_OAUTH_QUERY_KEYS.forEach((key) => {
    currentUrl.searchParams.delete(key);
  });
  currentUrl.hash = normalizeHash(targetHash);
  return currentUrl.toString();
}

export function clearTeacherOauthQueryInPlace(targetHash = '') {
  window.history.replaceState({}, document.title, buildTeacherCleanUrl(targetHash));
}

export function redirectToCleanTeacherLogin(loginState) {
  window.location.replace(buildTeacherCleanUrl(getTeacherLoginPath(loginState)));
}



// WEBPACK FOOTER //
// ./src/utils/teacherAuth.js